import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import { Modal, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import logo_between from '../../../../public/assets/logo-white.jpeg';
import Box from '@mui/material/Box';
import LeadService from '../../../core/services/leadsService';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useSelector } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import ChatIcon from '@mui/icons-material/Chat';
import toast from 'react-hot-toast';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import SendIcon from '@mui/icons-material/Send';
import './Chat.css';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
const useStyles = makeStyles({});

const ChatModule = ({ leadId, icaImage, leadImge, status, buyer_latitude, buyer_longitude, name }) => {
    const userId = useSelector((slice) => slice.auth.user.id);
    const userImage = useSelector((slice) => slice.auth.user.profile_image);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [zoomLevel, setZoomLevel] = useState(13);
    const [logOutModal, setLogOutModal] = useState(false);
    const getChats = async (chatId) => {
        try {
            const res = await LeadService.getIsaChat(chatId);
            if (res.data.success) {
                setMessages(res.data.leadDetails || []);
            } else {
                setMessages([]);
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } 
    };
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (open) {
                getChats(leadId);
            }
        }, 3000); // Call every 3 seconds
    
        return () => clearInterval(intervalId);
    }, [open, leadId,]);

    function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    var inputElement = document.getElementById('messageinput');
    var modal = document.querySelector('.modal');
    var modalContent = document.querySelector('.modal-content');

    function isLastMessageVisible() {
        var scrollableDivRect = modalContent?.getBoundingClientRect();
        var lastMessageRect = inputElement?.getBoundingClientRect();

        // Check if the last message is within the visible area of the scrollable div
        const res = lastMessageRect?.top >= scrollableDivRect?.top && lastMessageRect?.bottom <= scrollableDivRect?.bottom;
        if (res) {
            document.getElementById('scrollButton').style.visibility = 'hidden';
        } else {
            document.getElementById('scrollButton').style.visibility = 'visible';
        }
    }

    // Example usage
    // if (isLastMessageVisible()) {
    //     console.log('Last message is visible');
    // } else {
    //     console.log('Last message is not visible');
    // }

    function checkInputInView() {
        if (isInViewport(inputElement)) {
            console.log('Input is in view');
            document.getElementById('scrollButton').style.visibility = 'hidden';
        } else {
            console.log('Input is not in view');
            document.getElementById('scrollButton').style.visibility = 'visible';
        }
    }

    const handleOpen = async () => {
        setOpen(true);
        getChats(leadId);
    };
    const handleClose = () => setOpen(false);

    const messagesEndRef = useRef(null);

    // Function to scroll to the bottom of the messages div
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const [messages, setMessages] = useState([
        { id: 1, text: 'Hello!', sender: 'receiver', imageUrl: 'path/to/receiverImage.jpg' },
        { id: 2, text: 'Hi there!', sender: 'sender', imageUrl: 'path/to/senderImage.jpg' },
    ]);
    const [newMessage, setNewMessage] = useState('');
    const sendMessage = async (event) => {
        event.preventDefault();
        if (!newMessage.trim()) return;
        const nextMessage = {
            lead_id: leadId,
            message: newMessage,
            timestamp: new Date(),
            content_type: 'text',
            sender_id: userId,
        };
        const messageCopy = [...messages];
        messageCopy.push(nextMessage);
        setMessages([...messageCopy]);
        scrollToBottom();
        try {
            const res = await LeadService.addIsainternalchat(nextMessage);
            if (!res?.data.success) {
                messageCopy.pop();
                setMessages([...messageCopy]);
                scrollToBottom();
            }
        } catch (error) {
            messageCopy.pop();
            setMessages([...messageCopy]);
            scrollToBottom();
        }

        scrollToBottom();

        setNewMessage('');
    };

    // Simulate receiving a message
    const receiveMessage = () => {
        const nextMessage = {
            id: messages.length + 1,
            text: randomMessage,
            sender: 'receiver',
        };
        setMessages([...messages, nextMessage]);
    };

    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ● Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
        };
        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };
    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(status);
    const handleZoomIn = () => {
        setZoomLevel((prevZoom) => prevZoom + 1);
    };

    const handleZoomOut = () => {
        setZoomLevel((prevZoom) => Math.max(1, prevZoom - 1));
    };
    const scrollToBottomfunc = () => {
        document.getElementById('scrollButton').addEventListener('click', function () {
            var scrollableDiv = document.getElementById('scrollableDiv');
            scrollableDiv.scrollTop = scrollableDiv.scrollHeight; // Scroll to the bottom
        });
    };
    console.log(inputElement);
    if (inputElement) {
        modalContent?.addEventListener('scroll', isLastMessageVisible);
    }
    // window.addEventListener('scroll', function() {
    //     if (isInViewport(inputElement)) {
    //         console.log('Input is in view');
    //     } else {
    //         console.log('Input is not in view');
    //     }
    // });

    let sdiv = document.getElementById('scrollableDiv');
    // useEffect(() => {

    //     if () {
    //         console.log('Scroll is active');
    //     } else {
    //         console.log('Scroll is not active');
    //     }
    // });

    return (
        <div style={{ position: 'relative' }}>
            <ChatIcon onClick={handleOpen} style={{ width: '79px', height: '79px', cursor: 'pointer' }} />
            <Typography style={{ fontSize: '18px', color: 'gray', fontWeight: 'bold', cursor: 'pointer' }} onClick={handleOpen}>
                Chat Here
            </Typography>
            <Modal className="modal" open={open}  aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: 'auto',
                            height: 'auto',
                            overflow: 'auto',
                        }}
                    >
                        <IconButton style={{ position: 'absolute', top: '0px', right: '20px' }} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>

                        <div style={{ marginTop: '20px' }}>
                            <div style={{ marginTop: '20px', position: 'relative' }}>
                                <Box>
                                    {/* google image */}
                                    <img
                                        src={`https://maps.googleapis.com/maps/api/staticmap?zoom=${zoomLevel}&size=571x170&maptype=roadmap&center=${buyer_latitude},${buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                        alt="Static map"
                                        style={{ width: '593px', height: '170px', borderRadius: '10px' }}
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 4,
                                            right: 19,
                                        }}
                                    >
                                        <Button
                                            onClick={handleZoomIn}
                                            variant="outlined"
                                            style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                        >
                                            <AddIcon />
                                        </Button>
                                        <Button
                                            onClick={handleZoomOut}
                                            variant="outlined"
                                            style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                        >
                                            <RemoveIcon />
                                        </Button>
                                    </div>
                                </Box>
                                <Box
                                    style={{
                                        position: 'absolute',
                                        top: '53px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        zIndex: 10,
                                        display: 'flex',
                                        alignItems: 'center',
                                        borderRadius: '4px',
                                        padding: '5px',
                                    }}
                                >
                                    <img
                                        src={logo_between}
                                        alt=""
                                        style={{ width: '44px', height: '44px', borderRadius: '24px', border: '1px solid gray' }}
                                    />
                                </Box>
                            </div>
                            {/*  */}
                            <div
                                style={{
                                    display: 'flex',
                                    marginTop: '15px',
                                    marginBottom: '15px',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <div style={{ display: 'grid' }}>
                                    <div>
                                        <span style={{ fontSize: '22px', fontWeight: '700', color: '#606060' }}>{name}</span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '5px' }}>
                                    <div
                                        style={{
                                            ...divStyle,
                                            borderRadius: '10px',
                                            padding: '3px',
                                            width: 'auto',
                                            display: 'flex',
                                            gap: '2px',
                                            marginRight: '0px',
                                            height: '41px',
                                        }}
                                    >
                                        <div style={{ marginTop: '3px', cursor: 'pointer' }}>{formattedStatus}</div>
                                    </div>
                                </div>
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '300px',
                                    maxWidth: '600px',
                                    margin: 'auto',
                                    border: '1px solid #ccc',
                                    overflow: ' hidden',
                                }}
                            >
                                <div
                                    className="modal-content"
                                    id="scrollableDiv"
                                    style={{
                                        flexGrow: '1',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '10px',
                                        overflowY: 'auto',
                                    }}
                                >
                                    {messages?.map((message, index) => (
                                        <div
                                            id={messages.length - 1 === index ? 'messageinput' : ''}
                                            ref={messagesEndRef}
                                            key={message.id}
                                            className={`message ${message?.sender_id === userId ? 'right' : 'left'}`}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: message?.sender_id === userId ? 'row-reverse' : 'row',
                                                    gap: '5px',
                                                }}
                                            >
                                                <div>
                                                    <Avatar
                                                        src={
                                                            message?.sender_id === userId
                                                                ? `https://iconnctapp.com/${icaImage}`
                                                                : `https://iconnctapp.com/${leadImge}`
                                                        }
                                                        className="profile-image"
                                                    />
                                                </div>
                                                <div style={{ marginTop: '8px' }}>
                                                    <span className="text">{message?.message}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <form onSubmit={sendMessage} className="send-message-form">
                                    <input
                                        type="text"
                                        value={newMessage}
                                        onChange={(e) => setNewMessage(e.target.value)}
                                        placeholder="Type your message here..."
                                    />
                                    <button type="submit">
                                        <SendIcon />
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                    {messages.length && sdiv?.scrollHeight > sdiv?.clientHeight && (
                        <IconButton
                            id="scrollButton"
                            style={{
                                position: 'fixed',
                                bottom: '300px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                zIndex: '999', // Ensure button stays on top of other content
                            }}
                            onClick={scrollToBottomfunc}
                            aria-label="delete"
                        >
                            <ExpandCircleDownIcon sx={{ color: 'black' }} />
                        </IconButton>
                    )}
                </div>
            </Modal>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </div>
    );
};
export default ChatModule;
